import * as React from "react";
import { NavLink as RouterLink } from "react-router-dom";

export default class LinkExternal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    // @TODO the activeClassName is not working with RouterLink to apply the active state
    // Also this won't work with non-router link.
    let { isMobile, activeClassName, isHref, ...rest } = this.props;
    return /^https?:\/\//.test(rest.to) || isHref === true ? (
      <a href={this.props.to} {...rest} />
    ) : (
      <RouterLink activeClassName={activeClassName} {...rest} />
    );
  }
}
